import { SendEventProps } from '../../interface/biEvents';

export const mpContactMeClicked = () =>
    ({
        eventName: 'Clicked contact me',
        params: {
            'Source component': 'Gig page seller card',
        },
    } satisfies SendEventProps);
